import ACTIONS_REPORT_DEFINITION from '../_constants/reportDefinition.constants';

const initialState = {
  byId: {},
};

export function reportDefinitionReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_REPORT_DEFINITION.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_REPORT_DEFINITION.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_REPORT_DEFINITION.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default reportDefinitionReducer;
